import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Button, ComboBoxStateContext, SelectStateContext } from "react-aria-components";
import { ChevronDown } from "../../icons/line.js";
import { button, chevronIcon } from "./ChevronButton.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ChevronButton(t0) {
  const $ = _c(11);
  const {
    element: t1,
    isOpen: isOpenProp,
    onClick
  } = t0;
  const element = t1 === undefined ? "button" : t1;
  const comboboxState = React.useContext(ComboBoxStateContext);
  const selectState = React.useContext(SelectStateContext);
  const isOpen = isOpenProp ?? comboboxState?.isOpen ?? selectState?.isOpen ?? false;
  const ButtonComponent = element === "button" ? Button : "div";
  let t2;
  if ($[0] !== onClick || $[1] !== selectState) {
    t2 = () => {
      if (selectState) {
        selectState.setOpen(!selectState.isOpen);
      } else {
        if (onClick) {
          onClick();
        }
      }
    };
    $[0] = onClick;
    $[1] = selectState;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isOpen) {
    t3 = chevronIcon({
      isOpen
    });
    $[3] = isOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = /*#__PURE__*/_jsx(ChevronDown, {
      className: t3
    });
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== ButtonComponent || $[8] !== t2 || $[9] !== t4) {
    t5 = /*#__PURE__*/_jsx(ButtonComponent, {
      "aria-hidden": "true",
      className: button,
      onClick: t2,
      children: t4
    });
    $[7] = ButtonComponent;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
//# sourceMappingURL=ChevronButton.js.map